import { apiService } from '..';
import { ToastSwal } from '../../components/components/general/toastSwals/toastSwal';
import { PostQuestionResponse } from '../../shared/types/assistant';
import { Attachment } from '../../shared/types/shared';

interface TendersAssistantBody {
    threadId: string;
    attachments?: Attachment[];
    question: string;
    tenderId?: string;
}

export const updateTendersAssistant = async (
    threadId: string,
    question: string,
    tenderId: string,
    files?: Attachment[]
): Promise<PostQuestionResponse | undefined> => {
    try {
        const body: TendersAssistantBody = {
            threadId,
            attachments: files,
            question,
            tenderId,
        };

        const resp = await apiService.post<PostQuestionResponse>(
            `/api/sam-assistant/tenders-assistant/${tenderId}`,
            body
        );

        if (resp?.errors) {
            const errors = resp.errors;
            if (errors['[SAM_ASSISTANT] INVALID_FILE_TYPE']) {
                ToastSwal.fire({
                    text: 'Solo se permiten archivos .docx, .pptx, .xlsx, .pdf o .txt',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            } else {
                ToastSwal.fire({
                    text: 'Ocurrió un error, intenta de nuevo más tarde',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            }
            return undefined;
        }

        return resp;
    } catch (error) {
        ToastSwal.fire({
            text: 'Ocurrió un error, intenta de nuevo más tarde',
            icon: 'error',
            timer: 5000,
            position: 'center-end',
        });
        return undefined;
    }
};

export const createTendersAssistant = async (
    threadId: string,
    question: string,
    files?: Attachment[]
): Promise<PostQuestionResponse | undefined> => {
    try {
        const body: TendersAssistantBody = {
            threadId,
            attachments: files,
            question,
        };

        const resp = await apiService.post<PostQuestionResponse>(
            '/api/sam-assistant/tenders-assistant',
            body
        );

        if (resp?.errors) {
            const errors = resp.errors;
            if (errors['[SAM_ASSISTANT] INVALID_FILE_TYPE']) {
                ToastSwal.fire({
                    text: 'Solo se permiten archivos .docx, .pptx, .xlsx, .pdf o .txt',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            } else {
                ToastSwal.fire({
                    text: 'Ocurrió un error, intenta de nuevo más tarde',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            }
            return undefined;
        }

        return resp;
    } catch (error) {
        ToastSwal.fire({
            text: 'Ocurrió un error, intenta de nuevo más tarde',
            icon: 'error',
            timer: 5000,
            position: 'center-end',
        });
        return undefined;
    }
};
